import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AdminCompany } from "../../../domain/administrator/model";

type CompanyByIdState = {
  loading: boolean;
  data: AdminCompany;
};

const initialState: CompanyByIdState = {
  loading: false,
  data: {
    name: "",
    id: "",
    activity: null,
    color: null,
    employeesTreatment: null,
    image: null,
    numberOfEmployees: null,
    cnpj: null,
    operationField: null,
    paid: false,
    createdAt: null,
    updatedAt: null,
  },
};

const dataSlice = createSlice({
  name: "load-company-by-id",
  initialState: initialState,
  reducers: {
    eraseCompanyByIdStore: () => {
      return { ...initialState };
    },
    setCompanyByIdLoading: (state) => {
      state.loading = true;
    },
    setCompanyByIdResult: (state, action: PayloadAction<AdminCompany>) => {
      state.data = action.payload;
      state.loading = false;
    },
    setCompanyByIdFailure: (state) => {
      state.loading = false;
    },
  },
});

export const {
  eraseCompanyByIdStore,
  setCompanyByIdFailure,
  setCompanyByIdLoading,
  setCompanyByIdResult,
} = dataSlice.actions;

export default dataSlice.reducer;
